import React from "react";
import { useMarketingCopy } from "./MarketingShell";

export default function SharePageLink() {
  const { routes } = useMarketingCopy();
  const [status, setStatus] = React.useState<"idle" | "copied" | "failed">(
    "idle",
  );
  const [url, setUrl] = React.useState("");
  const copy = async () => {
    const address = new URL(window.location.pathname, window.location.origin)
      .href;
    setUrl(address);
    try {
      await navigator.clipboard.writeText(address);
      setStatus("copied");
    } catch {
      setStatus("failed");
    }
  };
  return (
    <div className="share-page-link">
      <button onClick={copy}>
        {routes.copyLink}
        <span aria-hidden="true">↗</span>
      </button>
      <span role="status">{status === "copied" ? routes.copied : ""}</span>
      {status !== "idle" && (
        <label>
          {routes.linkLabel}
          <input
            value={url}
            readOnly
            onFocus={(event) => event.currentTarget.select()}
          />
        </label>
      )}
    </div>
  );
}
